var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-cont", staticStyle: { height: "'100vh'" } },
    [
      _c(
        "el-button",
        {
          attrs: { slot: "reference" },
          on: { click: _vm.handlerClick },
          slot: "reference",
        },
        [
          _c("el-badge", { attrs: { value: _vm.alarmCount, max: 99 } }, [
            _c("i", {
              staticClass: "icon-alarm-clock",
              attrs: { title: "布告通知" },
            }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          staticStyle: { height: "'90vh'" },
          attrs: { title: "布告通知", visible: _vm.drawer },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", [
            _c(
              "button",
              { class: { open: _vm.pop }, on: { click: _vm.handlerPop } },
              [
                _vm._v(
                  "\n        弹窗" +
                    _vm._s(_vm.pop ? "开启" : "关闭") +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c("button", { on: { click: _vm.refreshList } }, [
              _vm._v("\n        重载\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.infiniteLoad,
                  expression: "infiniteLoad",
                },
              ],
              staticClass: "infinite-list block fullHeight",
              attrs: { "infinite-scroll-disabled": "infiniteDisabled" },
            },
            [
              _vm._l(_vm.noticeList, function (item, index) {
                return _c(
                  "el-card",
                  {
                    key: index,
                    staticClass: "infinite-list-item card",
                    attrs: { "body-style": { paddingTop: "0px" } },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "clearfix title",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [_c("span", [_vm._v(_vm._s(item.sendTitle))])]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "send-dept" }, [
                        _vm._v(" " + _vm._s(item.sendDept) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(item.sendContent))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bottom clearfix" },
                        [
                          _c("time", { staticClass: "time" }, [
                            _vm._v(
                              _vm._s(item.deptName) +
                                " " +
                                _vm._s(item.sendTime)
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "button",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handlerRead(item)
                                },
                              },
                            },
                            [_vm._v("未阅")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.loading
                ? _c("p", { staticClass: "flex-center" }, [_vm._v("加载中...")])
                : _vm._e(),
              _vm._v(" "),
              _vm.noMore
                ? _c("p", { staticClass: "flex-center" }, [
                    _vm._v("没有更多了"),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }